import React from 'react';

import { createClassName } from 'utils/createClassName';

import './paragraphStyles.scss';

type Props = {
  margin?: 'm' | 'l';
};

export const ParagraphComponent: React.FC<Props> = (props) => {
  const { children, margin = 'm' } = props;

  const className = createClassName('paragraph')({ margin });

  return <div className={className}>{children}</div>;
};
